import axios from "../utils/axios";
import { environment } from "environments/environment";

const baseURL = environment.apiUrl;

export const loginAPI = async (model) => {
  const response = await axios.post(`${baseURL}/auth/login`, model);
  return response;
};

export const registerAPI = async (model) => {
  const response = await axios.post(`${baseURL}/auth/register`, model);
  return response;
};

export const changePasswordAPI = async (model) => {
  const response = await axios.post(`${baseURL}/auth/change-password`, model);
  return response;
};

export const getProxyUserToken = async (model) => {
  const response = await axios.post(`${baseURL}/auth/getProxyUserToken`, model);
  return response;
};

export const activationUser = async (model) => {
  const response = await axios.post(`${baseURL}/auth/activation-user`, model);
  return response;
};

export const enableOtp = async (model) => {
  const response = await axios.post(`${baseURL}/auth/enable-otp`, model);
  return response;
};

export const getVerificationCode = async ({ registryNo, cellPhone }) => {
  const query = `?registryNo=${encodeURIComponent(registryNo)}&cellPhone=${encodeURIComponent(
    cellPhone
  )}`;
  const response = await axios.post(`${baseURL}/auth/get-verification-code${query}`);
  return response;
};
